function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M62.4167 8.5H51.2222V3.1875C51.2222 1.42109 50.0705 0 48.6389 0H19.3611C17.9295 0 16.7778 1.42109 16.7778 3.1875V8.5H5.58333C4.15174 8.5 3 9.92109 3 11.6875V19.125C3 23.8664 5.42188 28.7406 9.66285 32.4992C13.0535 35.5141 17.176 37.4266 21.5031 38.0375C24.883 44.957 28.8333 47.8125 28.8333 47.8125V57.375H23.6667C19.867 57.375 16.7778 60.1242 16.7778 64.8125V66.4062C16.7778 67.2828 17.359 68 18.0694 68H49.9306C50.641 68 51.2222 67.2828 51.2222 66.4062V64.8125C51.2222 60.1242 48.133 57.375 44.3333 57.375H39.1667V47.8125C39.1667 47.8125 43.117 44.957 46.4969 38.0375C50.8347 37.4266 54.9573 35.5141 58.3372 32.4992C62.5674 28.7406 65 23.8664 65 19.125V11.6875C65 9.92109 63.8483 8.5 62.4167 8.5ZM13.6885 25.6063C11.0622 23.2688 9.88889 20.6656 9.88889 19.125V17H16.7993C16.9069 21.3297 17.4236 25.1281 18.1771 28.4484C16.5517 27.7578 15.034 26.8016 13.6885 25.6063ZM58.1111 19.125C58.1111 21.2633 56.2059 23.9195 54.3115 25.6063C52.966 26.8016 51.4375 27.7578 49.8122 28.4484C50.5656 25.1281 51.0823 21.3297 51.1899 17H58.1111V19.125Z",
  fill: "url(#paint0_linear_107_69)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_107_69",
  x1: 3,
  y1: 34,
  x2: 65,
  y2: 34,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A77C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00B6DE"
})));

var SvgTrophy = function SvgTrophy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrophy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trophy.f4219bab.svg";
export { ForwardRef as ReactComponent };